(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaInstructionController', RcopiaInstructionController);

    RcopiaInstructionController.$inject = ['$scope', '$state', 'RcopiaInstruction', 'RcopiaInstructionSearch'];

    function RcopiaInstructionController ($scope, $state, RcopiaInstruction, RcopiaInstructionSearch) {
        var vm = this;

        vm.rcopiaInstructions = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            RcopiaInstruction.query(function(result) {
                vm.rcopiaInstructions = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            RcopiaInstructionSearch.query({query: vm.searchQuery}, function(result) {
                vm.rcopiaInstructions = result;
            });
        }    }
})();
